import { ColDef } from "@ag-grid-community/core";
import { GetRevoked, GetStatusChip } from "./components/PiTableRenderers";

export const PIDashboardColumns: ColDef[] = [
    {
        field: "fullName",
        headerName: "Full Name",
        flex: 1,
    },
    {
        field: "email",
        headerName: "Email",
        flex: 1,
    },
    {
        field: "ducStatus",
        headerName: "Duc Status",
        cellRenderer: GetStatusChip,
        flex: 1,
    },
    {
        field: "ducExpiry",
        headerName: "Duc expiry",
        flex: 1,
    },
    {
        field: "trainingStatus",
        headerName: "Training Status",
        cellRenderer: GetStatusChip,
        flex: 1,
    },

    {
        field: "remove",
        headerName: "Remove",
        flex: 1,
        maxWidth: 140,
        cellStyle: { textAlign: 'center' },
        cellRenderer: GetRevoked,
    }

]